(function() {
  'use strict';

  var getCookie = function(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  var setCookie = function(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
  };

  var SESSION_TIMEOUT = 20 * 60 * 1000;
  var COMPLETED_FIRST_SESSION = 'portos_completed_first_session';
  var SESSION_TIMESTAMP = 'portos_session_timestamp';

  var completedFirstSession = getCookie(COMPLETED_FIRST_SESSION);
  var sessionTimestamp = getCookie(SESSION_TIMESTAMP);
  var now = new Date().getTime();
  var status;

  if (completedFirstSession) {
    status = 'returning';
    setCookie(COMPLETED_FIRST_SESSION, 'true', 365);
  } else {
    if (sessionTimestamp) {
      var lastActivity = parseInt(sessionTimestamp, 10);
      var timeSinceLastActivity = now - lastActivity;
      
      if (timeSinceLastActivity >= SESSION_TIMEOUT) {
        status = 'returning';
        setCookie(COMPLETED_FIRST_SESSION, 'true', 365);
      } else {
        status = 'new';
      }
    } else {
      status = 'new';
    }
  }

  setCookie(SESSION_TIMESTAMP, now.toString(), 20 / (60 * 24));

  document.documentElement.setAttribute('data-visitor-status', status);
  window.visitorStatus = status;

})();

